import React, { useEffect, useRef, useState } from "react";
import { useAppStore } from "./AppStore";
import Ico from "./Ico";
import { rankTiers } from "../mock";
import { PartyPopper, Gift } from "lucide-react";

const COLORS = ["#f5911e", "#3b57c9", "#4fae3f", "#e6b325", "#4fc3e8", "#e0533d", "#8b5cf6", "#ff8a1e"];

export default function CelebrationOverlay() {
  const { rankIndex } = useAppStore();
  const prev = useRef(rankIndex);
  const [tier, setTier] = useState(null);
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    if (rankIndex > prev.current) {
      setTier(rankTiers[rankIndex]);
      // build a fresh confetti burst
      setPieces(
        Array.from({ length: 90 }).map((_, i) => ({
          id: i,
          left: Math.random() * 100,
          size: 6 + Math.random() * 9,
          dur: 1.8 + Math.random() * 2.2,
          delay: Math.random() * 0.8,
          color: COLORS[i % COLORS.length],
          round: i % 3 === 0,
          sway: (Math.random() * 2 - 1) * 40,
        }))
      );
    }
    prev.current = rankIndex;
  }, [rankIndex]);

  if (!tier) return null;

  return (
    <div className="absolute inset-0 z-[80] grid place-items-center overflow-hidden bg-[#0e163d]/85 px-6">
      {/* confetti shower */}
      {pieces.map((p) => (
        <span
          key={p.id}
          style={{
            position: "absolute",
            top: "-28px",
            left: `${p.left}%`,
            width: p.size,
            height: p.round ? p.size : p.size * 0.45,
            background: p.color,
            borderRadius: p.round ? "9999px" : "2px",
            "--sway": `${p.sway}px`,
            animation: `gdConfetti ${p.dur}s ${p.delay}s cubic-bezier(.25,.6,.4,1) forwards`,
          }}
        />
      ))}

      {/* rank-up card */}
      <div className="gd-enter relative z-10 w-full max-w-[320px] rounded-3xl bg-white p-6 text-center">
        <div className="mx-auto grid h-20 w-20 place-items-center rounded-3xl gd-float" style={{ background: tier.color }}>
          <Ico name={tier.icon} size={38} color="#fff" />
        </div>
        <div className="mt-3 flex items-center justify-center gap-1.5 text-[#f5911e]">
          <PartyPopper size={18} /><span className="text-xs font-extrabold tracking-wide">NEW RANK UNLOCKED!</span>
        </div>
        <h3 className="mt-1 text-2xl font-black text-[#1f2a52]">{tier.title}</h3>
        <p className="mt-1 text-sm text-[#5b648a]">You've been promoted to the <b>{tier.tier}</b> tier — payment's in and new perks are unlocked!</p>
        <div className="mt-3 rounded-2xl bg-[#f4f9f3] p-3 text-left">
          <div className="mb-1 flex items-center gap-1.5 text-[11px] font-extrabold text-[#3d8f34]"><Gift size={13} /> New Perks &amp; Rewards</div>
          {tier.perks.slice(0, 3).map((perk) => (
            <div key={perk} className="flex items-center gap-2 py-0.5 text-[12px] font-medium text-[#3a4468]">
              <span className="h-1.5 w-1.5 rounded-full" style={{ background: tier.color }} /> {perk}
            </div>
          ))}
        </div>
        <button onClick={() => setTier(null)} className="gd-blue-btn mt-4 w-full rounded-2xl py-3.5 font-extrabold">Awesome!</button>
      </div>
    </div>
  );
}
